import { render } from "./RcDivider.vue?vue&type=template&id=7d66ee37&scoped=true"
const script = {}

import "./RcDivider.vue?vue&type=style&index=0&id=7d66ee37&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d66ee37"]])

export default __exports__